import React from 'react'

import "./Insignia.css";

import defaultImage from "../images/insignia/NH.png"; // New Hire or Rampie
import FOA from "../images/insignia/FOA.png";
import FO1 from "../images/insignia/FO1.png";
import FO2 from "../images/insignia/FO2.png";
import FO3 from "../images/insignia/FO3.png";
import C1 from "../images/insignia/C1.png";
import C2 from "../images/insignia/C2.png";
import C3 from "../images/insignia/C3.png";
import C4 from "../images/insignia/C4.png";
import C5 from "../images/insignia/C5.png";

const InsigniaRank = (props) => {
    let image = defaultImage;
    
    switch(props.rank) {
        case "New Hire":
            image = defaultImage; // Rampie
            break;
        case "Second Officer":
            image = FOA;
            break;
        case "Junior First Officer":
            image = FO1;
            break;
        case "First Officer":
            image = FO2;
            break;
        case "Senior First Officer":
            image = FO3;
            break;
        case "Captain":
            image = C1;
            break;
        case "Ferry Captain":
            image = C2;
            break;
        case "Charter Captain":
            image = C3;
            break;
        case "Merit Captain":
            image = C4;
            break;
        case "Senior Captain":
            image = C5;
            break;
        default:
            image = defaultImage;
    }
    
    return (
        <div className="insignia-rank">
            <img className="insignia-rank-image" src={image} alt="Insignia" />
        </div>
    )
}
export default InsigniaRank;
